import React, {useEffect, useState} from 'react';
import {Popover} from 'antd';
import iconTourGuide from '../images/icon_tour_guide.png';
import iconTourGuideDark from '../images/icon_tour_guide_dark.png';
import iconTourClose from '../images/icon_tour_close.png';
import iconTourCloseDark from '../images/icon_tour_close_dark.png';
import iconTourBgRt from '../images/icon_tour_bg_rt.png';
import iconTourShading from '../images/icon_tour_shading.png';
import iconTourBgLb from '../images/icon_tour_bg_lb.png';
import {getStorage, setStorage} from '../../../utils/storage';
import './index.less';

const GuidePopover = (props) => {
    const {
        open = false,
        title,
        description,
        descImage,
        operateExtraContent,
        cancelText,
        confirmText,
        placement = 'top',
        closable = false,
        beforeCancel,
        beforeConfirm,
        beforeClose,
        mode = 'dark',
        destroyTooltipOnHide = false,
        getPopupContainer = () => document.body,
        overlayClassName = '',
        guideKey,
        autoCloseSec = 0,
        zIndex,
        children
    } = props;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (guideKey && open) {
            const guide = getStorage(guideKey);
            if (!guide) {
                setVisible(true);
                if (!isNaN(+autoCloseSec) && +autoCloseSec > 0) {
                    setTimeout(() => {
                        handleClose();
                    }, +autoCloseSec * 1000);
                }
            }
        }
        else {
            setVisible(open);
            if (open && !isNaN(+autoCloseSec) && +autoCloseSec > 0) {
                setTimeout(() => {
                    handleClose();
                }, +autoCloseSec * 1000);
            }
        }
    }, [open]);

    const handleConfirm = e => {
        if (e) {
            e.stopPropagation();
        }
        setVisible(false);
        if (guideKey) {
            setStorage(guideKey, true);
        }
        if (beforeConfirm) {
            beforeConfirm();
        }
    };

    const handleCancel = e => {
        if (e) {
            e.stopPropagation();
        }
        setVisible(false);
        if (guideKey) {
            setStorage(guideKey, true);
        }
        if (beforeCancel) {
            beforeCancel();
        }
    };

    const handleClose = e => {
        if (e) {
            e.stopPropagation();
        }
        setVisible(false);
        if (guideKey) {
            setStorage(guideKey, true);
        }
        if (beforeClose) {
            beforeClose();
        }
    };

    const IconClose = (closable && <img className="ant-popover-title-close" onClick={handleClose} src={mode === 'light' ? iconTourCloseDark : iconTourClose} width={16} height={16} />);

    return <Popover
        key={guideKey ? guideKey : description}
        content={
            <React.Fragment>
                <div className="ant-popover-inner-content-icon-bg-rt">
                    <img src={iconTourBgRt} width={122} />
                </div>
                <div className="ant-popover-inner-content-icon-shading">
                    <img src={iconTourShading} width={68} />
                </div>
                <div className="ant-popover-inner-content-icon-bg-lb">
                    <img src={iconTourBgLb} width={101} />
                </div>
                <div
                    className="ant-popover-inner-content-desc"
                    style={(operateExtraContent || cancelText || confirmText || descImage) && {paddingBottom: '12px'}}
                >
                    {description}
                    <div style={{width: '16px', height: '16px', marginTop: '-1px'}}>
                        {!title ? IconClose : null}
                    </div>
                </div>
                {descImage && <div className="ant-popover-inner-content-image">
                    <img src={descImage} width={280} />
                </div>}
                {(operateExtraContent || cancelText || confirmText) && <div className="ant-popover-inner-content-operate">
                    <div className="ant-popover-inner-content-operate-count">
                        {operateExtraContent}
                    </div>
                    <div className="ant-popover-inner-content-operate-right">
                        {cancelText && <div className="ant-popover-inner-content-operate-prev" onClick={handleCancel}>
                            {cancelText}
                        </div>}
                        {confirmText && <div className="ant-popover-inner-content-operate-next" onClick={handleConfirm}>
                            {confirmText}
                        </div>}
                    </div>
                </div>}
            </React.Fragment>
        }
        title={
            title && <React.Fragment>
                <div className="ant-popover-title-left">
                    <img src={mode === 'light' ? iconTourGuideDark : iconTourGuide} width={18} height={18} />
                    <div className="ant-popover-title-content">{title}</div>
                </div>
                {IconClose}
            </React.Fragment>
        }
        visible={visible}
        placement={placement}
        destroyTooltipOnHide={destroyTooltipOnHide}
        getPopupContainer={getPopupContainer}
        zIndex={zIndex}
        overlayClassName={`huibo-novice-guide-popover ${overlayClassName} ${mode}`}
    >{children}</Popover>;
};

export default GuidePopover;